<template>
  <div class="wrapper" data-app>
    <div v-for="(i, id) in listData" :key="id">
      <ServiceBk
        v-if="objectData.type === TYPE_SERVICE.BOOKING"
        :object-data="i"
      />
      <ServiceShop
        v-if="objectData.type === TYPE_SERVICE.SHOP"
        :object-data="i"
      />
      <ServiceHio
        v-if="objectData.type === TYPE_SERVICE.HIO"
        :object-data="i"
      />
      <ServiceOther
        v-if="objectData.type === TYPE_SERVICE.OTHER"
        :object-data="i"
      />
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@/plugins/init";
import { decodeToken } from "@/utils/auth";
import { getBackGround } from "@/utils/wapAuth";
import { TYPE_SERVICE } from "@/utils/helper.js";
import ServiceBk from "./ServiceBk.vue";
import ServiceShop from "./ServiceShop.vue";
import ServiceHio from "./ServiceHio.vue";
import ServiceOther from "./ServiceOther.vue";

export default {
  components: {
    ServiceBk,
    ServiceShop,
    ServiceHio,
    ServiceOther
  }, //, Comment
  bodyClass: "data-detail-services",
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    objectData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      TYPE_SERVICE: TYPE_SERVICE,
      bg: getBackGround(),
      infoHeader: {
        title: this.$t("billDetails"),
        isShowHomeIcon: true
      },
      checked: false,
      large: "large",
      isShow: [],
      icons: {},
      form: {}
    };
  },
  created() {},

  watch: {},

  methods: {
    decodeToken,
    formatNumber
  },
  computed: {},
  mounted() {},

  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.divider {
  //position: absolute;
  left: 0;
  right: 0;
  margin: 10px 0;
}

.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .header-top {
    padding-top: 60px !important;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>

<style lang="scss">
.mt-0 {
  margin-top: 0 !important;
}

.pointer {
  cursor: pointer;
}

.border-1 {
  border: 1px solid #ababab;
  border-radius: 10px;
}

.icon-image {
  height: 30px !important;
}

.text-not-break {
  word-break: keep-all !important;
}
</style>
